// angular
import { Component, Input, OnInit } from '@angular/core';
import { CoreService } from '../../../core/core.service';
import { AppService } from '../../../app.service';
import { KlenicoMeService } from '../../me.service';
import { TranslateService } from '@ngx-translate/core';


@Component({
    selector: 'me-landing-page-product',
    templateUrl: './landing-page-product.component.html',
    styleUrls: ['./landing-page-product.component.scss']
})

export class MeLandingPageProductComponent implements OnInit {
    landingPageImageText = {};
    productPresentationFirst = {};
    productPresentationSecond = {};
    productOffer = {};
    data = [];
    folder = 'core';
    url = 'lp/products';

    constructor(
        public appService: AppService,
        public coreService: CoreService,
        public meService: KlenicoMeService,
        public translate: TranslateService
    ) {
       
    }

    ngOnInit() {
        this.meService.isLandingPage = true;
        this.getProduct();

        this.translate.onLangChange.subscribe(res => {
            this.getProduct();
        })
    }

    getProduct() {
        this.appService.getStoryBlokDataForClinic(this.url).subscribe(res => {
            let contents = res['story']['content']['content'] ?? [];
            this.data = contents;
            this.appService.isLoading = false;
        });

    }
}
